import { useEffect } from 'react';

import {
  useJobProspectsState,
  useJobProspectsActions,
} from './JobProspectsContext';

import {
  getJobProspects,
} from './restApi';

const JobProspectsLoader = ({ enrolled, tier, hasPaymentMethod, subscription }) => {
  const state = useJobProspectsState();
  const { initializeState, onResponse, onError } = useJobProspectsActions();

  useEffect(() => {
    initializeState({ enrolled, tier, hasPaymentMethod, subscription });
  }, []);

  useEffect(() => {
    if (state?.enrolled) {
      getJobProspects({ onResponse, onError });
    }
  }, [state?.enrolled]);

  return null;
};

export default JobProspectsLoader;
